import { __awaiter, __generator } from "tslib";
import { ActionExecutorEventEmitter, } from '@office-start/action-types';
import { logActionClickEvent, logActionGenericEvent, logActionPerfEvent, } from './actionTelemetry';
import { createNextActionEventHandler } from './nextActionEventHandler';
export var createActionExecutor = function (options) {
    var actionExecutorEventEmitter = new ActionExecutorEventEmitter();
    var actionExecutor = {
        /**
         * @param action Resolved office action to execute
         */
        executeActionAsync: function (action, telemetryConfig) { return __awaiter(void 0, void 0, void 0, function () {
            var startTime, execute, result;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        startTime = Date.now();
                        return [4 /*yield*/, import('@office-start/actions-executor')];
                    case 1:
                        execute = (_b.sent()).execute;
                        return [4 /*yield*/, execute(action, options, actionExecutorEventEmitter)];
                    case 2:
                        result = _b.sent();
                        // Log action complete perf event
                        logActionPerfEvent(telemetryConfig, startTime, (_a = result.actionLoadedTS) !== null && _a !== void 0 ? _a : Date.now());
                        // Log action click event
                        logActionClickEvent(telemetryConfig);
                        // Log action complete generic event with result
                        logActionGenericEvent(telemetryConfig, result);
                        return [2 /*return*/, result];
                }
            });
        }); },
    };
    createNextActionEventHandler(actionExecutorEventEmitter, actionExecutor, options.actionManager);
    return actionExecutor;
};
export var getExtraOptionsFromEnvironment = function (_a) {
    var componentContext = _a.componentContext, isDarkMode = _a.isDarkMode, isRecommendedFilesActionsApiEnabled = _a.isRecommendedFilesActionsApiEnabled, identity = _a.identity, odspShareApiEndPointBase = _a.odspShareApiEndPointBase, sharedContext = _a.sharedContext, workloads = _a.workloads, useCompliantShareApi = _a.useCompliantShareApi, shareUIPosition = _a.shareUIPosition, tokenProviderEnabled = _a.tokenProviderEnabled;
    var graphBaseUrl = sharedContext.graphApiRoot;
    var graphVersion = 'v1.0';
    var outlookWorkload = workloads.find(function (value) { return value.Id === "ShellMail" /* FirstPartyWorkloadIds.Outlook */; });
    var maybeOutlookWorkloadParameters = (outlookWorkload === null || outlookWorkload === void 0 ? void 0 : outlookWorkload.Title) && (outlookWorkload === null || outlookWorkload === void 0 ? void 0 : outlookWorkload.Url)
        ? {
            title: outlookWorkload.Title,
            url: outlookWorkload.Url,
        }
        : undefined;
    var oneDriveWorkload = workloads.find(function (value) { return value.Id === "ShellDocuments" /* FirstPartyWorkloadIds.OneDrive */; });
    var todoWorkload = workloads.find(function (value) { return value.Id === "ShellToDo" /* FirstPartyWorkloadIds.ToDo */; });
    var maybeTodoWorkloadParameters = (todoWorkload === null || todoWorkload === void 0 ? void 0 : todoWorkload.Title) && (todoWorkload === null || todoWorkload === void 0 ? void 0 : todoWorkload.Url)
        ? {
            title: todoWorkload.Title,
            url: todoWorkload.Url,
        }
        : undefined;
    var maybeTeamsWorkloadParameters = (sharedContext === null || sharedContext === void 0 ? void 0 : sharedContext.teamsUrl)
        ? {
            url: sharedContext.teamsUrl,
        }
        : undefined;
    var maybeSupportDocsWorkloadParameters = (sharedContext === null || sharedContext === void 0 ? void 0 : sharedContext.supportDocsUrl)
        ? {
            url: sharedContext.supportDocsUrl,
        }
        : undefined;
    var microsoftGraphOptions;
    var recommendedProviderOptions;
    return {
        getMicrosoftGraphOptions: function () { return __awaiter(void 0, void 0, void 0, function () {
            var actionExecutor, createLink, createMicrosoftGraphClient, downloadContentAsBlob, getDriveItem, getGraphItem, getSharesAPIItem, getUrlFileInfo, tasksReadWriteAuthenticationHandlerOptions, uploadFile;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (microsoftGraphOptions) {
                            return [2 /*return*/, microsoftGraphOptions];
                        }
                        return [4 /*yield*/, import('@office-start/actions-executor')];
                    case 1:
                        actionExecutor = _a.sent();
                        createLink = actionExecutor.createLink, createMicrosoftGraphClient = actionExecutor.createMicrosoftGraphClient, downloadContentAsBlob = actionExecutor.downloadContentAsBlob, getDriveItem = actionExecutor.getDriveItem, getGraphItem = actionExecutor.getGraphItem, getSharesAPIItem = actionExecutor.getSharesAPIItem, getUrlFileInfo = actionExecutor.getUrlFileInfo, tasksReadWriteAuthenticationHandlerOptions = actionExecutor.tasksReadWriteAuthenticationHandlerOptions, uploadFile = actionExecutor.uploadFile;
                        microsoftGraphOptions = {
                            graphBaseUrl: graphBaseUrl,
                            graphVersion: graphVersion,
                            xhrOperationParameters: {
                                correlationId: componentContext.correlationId,
                                getAccessToken: componentContext.getAccessToken,
                                jwtAuthEnabled: componentContext.jwtAuthEnabled,
                                officeApiRoot: componentContext.officeHomeApiRoot,
                                graphApiRoot: graphBaseUrl,
                            },
                            wrapper: {
                                client: createMicrosoftGraphClient(componentContext.getAccessToken, graphBaseUrl, graphVersion),
                                createLink: createLink,
                                downloadContentAsBlob: downloadContentAsBlob,
                                getDriveItem: getDriveItem,
                                getGraphItem: getGraphItem,
                                getSharesAPIItem: getSharesAPIItem,
                                getUrlFileInfo: getUrlFileInfo,
                                tasksReadWriteAuthenticationHandlerOptions: tasksReadWriteAuthenticationHandlerOptions,
                                uploadFile: uploadFile,
                            },
                        };
                        return [2 /*return*/, microsoftGraphOptions];
                }
            });
        }); },
        getRecommendedProviderOptions: function () { return __awaiter(void 0, void 0, void 0, function () {
            var fileActionsApiEnabled, createRecommendedWrapper, recommendedWrapper;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (recommendedProviderOptions) {
                            return [2 /*return*/, recommendedProviderOptions];
                        }
                        fileActionsApiEnabled = isRecommendedFilesActionsApiEnabled();
                        if (!fileActionsApiEnabled) {
                            return [2 /*return*/, {
                                    fileActionsApiEnabled: fileActionsApiEnabled,
                                    recommendedWrapper: undefined,
                                }];
                        }
                        return [4 /*yield*/, import('@office-start/actions-executor')];
                    case 1:
                        createRecommendedWrapper = (_a.sent()).createRecommendedWrapper;
                        return [4 /*yield*/, createRecommendedWrapper()];
                    case 2:
                        recommendedWrapper = _a.sent();
                        recommendedProviderOptions = {
                            fileActionsApiEnabled: fileActionsApiEnabled,
                            recommendedWrapper: recommendedWrapper,
                        };
                        return [2 /*return*/, recommendedProviderOptions];
                }
            });
        }); },
        odspShareOptions: {
            correlationId: componentContext.correlationId,
            getAccessToken: componentContext.getAccessToken,
            market: componentContext.preferredCulture,
            shareApiEndPointBase: odspShareApiEndPointBase,
            useCompliantShareApi: useCompliantShareApi,
            shareUIPosition: shareUIPosition,
            tokenProviderEnabled: tokenProviderEnabled,
        },
        workloadOptions: {
            outlook: maybeOutlookWorkloadParameters,
            oneDrive: oneDriveWorkload &&
                oneDriveWorkload.Title &&
                oneDriveWorkload.Url
                ? {
                    title: oneDriveWorkload.Title,
                    url: oneDriveWorkload.Url,
                }
                : undefined,
            todo: maybeTodoWorkloadParameters,
            teams: maybeTeamsWorkloadParameters,
            supportDocs: maybeSupportDocsWorkloadParameters,
        },
        userIdentityOptions: {
            isMsa: identity.isMsa,
            tenantId: identity.tenantId,
            userPrincipalName: identity.userPrincipalName,
        },
        isDarkMode: isDarkMode,
    };
};
//# sourceMappingURL=actionExecutor.js.map